import {Component, OnDestroy} from '@angular/core';
import {ValidatedForm} from "../../forms/validated-form";
import {FormBuilder, Validators} from "@angular/forms";
import {Constants} from "../../util/constants";
import {BackendUser, BackendUserService} from "../../services/backend-user.service";
import {Router} from "@angular/router";
import {AlertService} from "../../services/alert.service";
import {HttpErrorResponse} from "@angular/common/http";
import {StateService} from "../../services/state.service";
import {Observable} from "rxjs";

@Component({
    templateUrl: './backend-user.component.html',
    styleUrls: ['./backend-user.component.css']
})
export class BackendUserComponent extends ValidatedForm implements OnDestroy {

    readonly TYPES = ['user', 'print', 'admin', 'super'];
    user: BackendUser;

    constructor(protected fb: FormBuilder,
                private router: Router,
                private state: StateService,
                private alertService: AlertService,
                private backendUserService: BackendUserService) {
        super(fb);
        this.user = this.state.get("currentBackendUser");
        this.initForm({
            email: {
                value: this.user?.email || '',
                validators: [Validators.required, Validators.pattern(Constants.EMAIl_REGEX)],
                messages: {required: Constants.ERR_REQUIRED, pattern: Constants.ERR_INVALID_EMAIL}
            },
            type: {
                value: this.user?.type || 'user'
            }
        });
        if (this.user)
            this.form.controls.email.disable();
    }

    ngOnDestroy() {
        this.state.clear("currentBackendUser");
    }

    get verb(): string {
        return this.user? 'Update' : 'Add';
    }

    canSubmit(): boolean {
        return this.form.valid && (!this.user ||
                (this.user.email != this.fields.email?.value.trim() || this.user.type != this.fields.type?.value));
    }

    submit() {
        let obs: Observable<any>;
        let action: string;
        if (this.user) {
            this.user.email = this.fields.email.value.trim();
            this.user.type = this.fields.type.value;
            obs = this.backendUserService.update(this.user);
            action = "updated";
        } else {
            obs = this.backendUserService.add(this.fields.email.value, this.fields.type.value);
            action = "added";
        }
        obs.pipe(
        ).subscribe((out) => {
            this.alertService.info(`User ${action} successfully`);
            this.router.navigateByUrl('/backend-users').then();
        }, (err: HttpErrorResponse) => {
            this.alertService.error(err.error.message);
        })
    }

    disableUser() {
        this.alertService.confirm("Are you sure you want to disable this user?")
            .subscribe((doIt) => {
                if (doIt) {
                    this.backendUserService.disable(this.user).pipe(
                    ).subscribe((out) => {
                        this.alertService.info("User disabled successfully");
                        this.router.navigateByUrl('/backend-users').then();
                    }, (err: HttpErrorResponse) => {
                        this.alertService.error(err.error.message);
                    });
                }
            });
    }

    enableUser() {
        this.backendUserService.enable(this.user).pipe(
        ).subscribe((out) => {
            this.alertService.info("User enabled successfully");
            this.router.navigateByUrl('/backend-users').then();
        }, (err: HttpErrorResponse) => {
            this.alertService.error(err.error.message);
        })
    }
}
